<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('information.forms.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('information.title') }} > </span>
            <span class="middle_loc">{{ $t('information.forms.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.list') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">

          <div class="top__component__fold__wrap" v-if="component_fold">
            <v-row class="top_search_content2">
              <v-col cols="12" md="3">
                <label class="nec_title">{{ $t('information.forms.fields.section') }}</label>
                <div class="input_text_type_basic wp100">
                  <div class="input_text_type_basic">
                    <v-select
                      dense
                      outlined
                      hide-details
                      v-model="searchOption.searchSection"
                      :items="$vuetify.rtl ? sectionTypeCodeListAr : sectionTypeCodeListEn"
                    >
                    </v-select>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label class="nec_title">{{ $t('information.forms.fields.title_forms_name') }}</label>
                <div class="input_text_type_basic wp100">
                  <v-text-field
                    :placeholder="$t('information.forms.fields.please_enter_title_forms_name')"
                    dense
                    outlined
                    hide-details
                    clearable
                    v-model="searchOption.searchKeyword"
                  >
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="3" class="mobile__dcolumn">
                <v-btn class="t_search_btn wp50" color="#a01c2a" dark height="40" @click="fnGetFormsList()">
                  <v-icon>mdi-magnify</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.search') }}
                </v-btn>
                <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                <v-btn class="t_search_btn wp50" color="#222" dense dark height="40" @click="fnReset()">
                  <v-icon>mdi-restart</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.reset') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>


          <!-- 상단 레이아웃 접는 기능영역 : S -->
          <div class="fold__actions__wrap">
            <v-btn @click="foldingActions()" :class="{actv : component_fold}" color="#dedede" small min-width="120px"><v-icon x-small color="#727272">mdi-triangle</v-icon></v-btn>
          </div>
          <!-- 상단 레이아웃 접는 기능영역 : E -->


          <v-data-table
            disable-sort
            :headers="$getHeaderType1(headerTxt, headers)"
            :items="formsList"
            hide-default-footer
            item-key="seq"
            :page.sync="paging.page"
            :items-per-page="paging.pageSize"
            @page-count="paging.pageCount = $event"
            class="elevation-0 mt-25 myapp_table_type2 type4"
            :mobile-breakpoint="MobileBreakPoint"
          >
          <template v-slot:item="{ item, index }">
            <tr>
              <td :class="$vuetify.rtl ? 'text-right' : 'text-left'">{{ $vuetify.rtl ? item.form_section_type_name_ar : item.form_section_type_name_en }}</td>
              <td :class="$vuetify.rtl ? 'text-right' : 'text-left'">{{ $vuetify.rtl ? item.subject_ar : (fnIsNull(item.subject_en) ? item.subject_ar : item.subject_en) }}</td>
              <td>
                <template v-if="fnIsNull( $vuetify.rtl ? item.attached_ar_file_key : item.attached_en_file_key )">
                  <v-icon></v-icon>
                </template>
                <template v-else>
                  <a class="attach__mt ty3" style="text-decoration:none" :href="downLoadUrl + ( $vuetify.rtl ? item.attached_ar_file_key : item.attached_en_file_key )">
                    <v-icon color="#a01c2a">mdi-email</v-icon>
                    <v-icon color="#fff" class="inner_icon">mdi-paperclip</v-icon>
                  </a>
                </template>
              </td>
              <td class="text-center">{{ fnConvertDateFormat(item.write_date) }}</td>
              <td>{{ item.read_count }}</td>
            </tr>
          </template>
          </v-data-table>

          <div class="v-data-table board_basic_wrap theme--light mb-30">
            <div class="v-data-table-footer page_nation_wrap">
              <pagination :paging.sync="paging" />
            </div>
          </div>
        </v-flex>

      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import Pagination from '@/components/layout/Pagination'
import requestApi from '@/utils/requestApi'
import eventBus from '@/utils/eventBus'
import utils from '@/utils/utils'

export default {
  components :{
    Pagination
  },
  data(){
    return {
      MobileBreakPoint : 0,
      component_fold : false,
      paging: {
        page: 1,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0
      },
      sectionTypeCodeListAr : [],
      sectionTypeCodeListEn : [],

      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',

      searchOption : {
        searchSection : '',
        searchKeyword : ''
      },

      headerTxt : {
        prefix : 'information.forms.fields.',
        txt : [ 'section','title','attachment','date','read' ]
      },

      headers: [
        { text: this.$t('information.forms.fields.section'), align: 'center', value: '', width:'20%'},
        { text: this.$t('information.forms.fields.title'), align: 'center', value: '', width:'60%'},
        { text: this.$t('information.forms.fields.attachment'), align: 'center', value: '', width: '180px'},
        { text: this.$t('information.forms.fields.date'), align: 'center', value: ''},
        { text: this.$t('information.forms.fields.read'),  align: 'center', value: ''},
      ],

      formsList : []
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    // 폴딩 브라우저 사이즈 체크 하여 접고 여는 부분 체크
    this.onResize()
    //window.addEventListener('resize', this.onResize, { passive: true })

    this.fnInit()
  },
  beforeDestroy (){
    // 리사이징 이벤트 제거
    if (typeof window === 'undefined') {
      return
    }
    window.removeEventListener('resize', this.onResize, { passive: true });
  },
  methods: {
    onResize () {
      this.component_fold = window.innerWidth < 960 ? false : true
    },
    foldingActions(){
      this.component_fold = !this.component_fold
    },
    fnInit(){
      let options = {
        upper_code: '6100',
        all: true
      }
      utils.fnGetCodeList(options).then(list => {
        this.sectionTypeCodeListAr = list.ar
        this.sectionTypeCodeListEn = list.en
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      this.fnGetFormsList()

    },
    fnReset(){
      this.searchOption.searchSection = ''
      this.searchOption.searchKeyword = ''
    },
    fnGetFormsList(){
      requestApi({
        url: '/info/forms',
        method: 'GET',
        data: this.searchOption,
        callback: (res) => {
          if (res.res_code === '200') {
            this.formsList = res.data.list
            this.paging.totalCount = res.data.list.length

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetFormsList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnIsNull(val){
      return utils.isNull(val)
    },
    fnConvertDateFormat(date){
      return utils.replaceAll(date, '-', '/')
    }

  }
}
</script>